/** Auto-generated by scripts/deploy.ts (local Hardhat) - do not edit */
export const LOCAL_MOCK_USDC_ADDRESS =
	"0x6d925938Edb8A16B3035A4cF34FAA090f490202a" as const;
